export const name = "CEIL";
export const summary = `Gets the smallest integral value that isn't less than \`X\`.`;
export const reference = `
## CEIL

Gets the smallest integral value that isn't less than \`X\`.

\`\`\`
CEIL(X)
\`\`\`

### Description

Returns the smallest integral value that isn't less than X.

| X | CEIL(X) |
| --- | --- |
| 2.0 | 2.0 |
| 2.3 | 3.0 |
| 2.8 | 3.0 |
| 2.5 | 3.0 |
| -2.3 | -2.0 |
| -2.8 | -2.0 |
| -2.5 | -2.0 |
| 0 | 0 |
| \`+inf\` | \`+inf\` |
| \`-inf\` | \`-inf\` |
| \`NaN\` | \`NaN\` |


### Return Data Type

| INPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| --- | --- | --- | --- | --- |
| OUTPUT | \`FLOAT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
